webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(24)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(11),
  /* template */
  __webpack_require__(35),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 9 */,
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Board__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Board___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Board__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_OptionsPane__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_OptionsPane___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_OptionsPane__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_blueimp_load_image__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_blueimp_load_image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_blueimp_load_image__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    Board: __WEBPACK_IMPORTED_MODULE_0__components_Board___default.a,
    OptionsPane: __WEBPACK_IMPORTED_MODULE_1__components_OptionsPane___default.a
  },

  data: function data() {
    return {
      playing: false,
      image: null
    };
  },


  methods: {
    start: function start() {
      this.playing = true;
      this.$refs.board.start({
        image: this.image,
        size: {
          horizontal: 3,
          vertical: 3
        }
      });
    },
    restart: function restart() {
      this.playing = false;
      this.$refs.optionsPane.reset();
    }
  },

  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_2_blueimp_load_image___default()('/static/heart.jpg', function (canvas) {
      _this.image = canvas.toDataURL();
    }, {
      maxWidth: 600,
      maxHeight: 600,
      minWidth: 200,
      minHeight: 200,
      canvas: true
    });
  }
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_sample__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_sample___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_sample__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Tile__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Tile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Tile__);






var backupTiles = null;

/* harmony default export */ __webpack_exports__["default"] = ({
  components: { Tile: __WEBPACK_IMPORTED_MODULE_2__Tile___default.a },

  data: function data() {
    return {
      image: null,
      showingOriginal: false,
      size: {
        horizontal: 0,
        vertical: 0
      },
      tiles: [],
      tileSize: {
        width: 0,
        height: 0
      },
      scaleFactor: 0.8
    };
  },


  computed: {
    frameSize: function frameSize() {
      return {
        width: this.tileSize.width * this.size.horizontal * this.scaleFactor + 'px',
        height: this.tileSize.height * this.size.vertical * this.scaleFactor + 'px'
      };
    },
    totalTiles: function totalTiles() {
      return this.size.horizontal * this.size.vertical;
    },
    valid: function valid() {
      if (!this.tiles.length) {
        return false;
      }

      for (var i = 0; i < this.totalTiles; ++i) {
        if (this.tiles[i].styles.order !== this.tiles[i].position) {
          return false;
        }
      }

      return true;
    }
  },

  methods: {
    start: function start(_ref) {
      var _this = this;

      var image = _ref.image,
          size = _ref.size;

      this.size = size;
      this.image = image;

      var img = new Image();
      img.onload = function () {
        _this.tileSize.width = Math.floor(img.width / size.horizontal);
        _this.tileSize.height = Math.floor(img.height / size.vertical);
        _this.generateTiles();
        _this.shuffleTiles();
      };
      img.src = image;
    },
    generateTiles: function generateTiles() {
      this.tiles = [];
      for (var i = 0; i < this.totalTiles; ++i) {
        this.tiles.push({
          styles: {
            background: i === 0 ? 'transparent' : 'url(' + this.image + ')',
            backgroundPositionX: '-' + i % this.size.horizontal * this.tileSize.width * this.scaleFactor + 'px',
            backgroundPositionY: '-' + Math.floor(i / this.size.horizontal) * this.tileSize.height * this.scaleFactor + 'px',
            width: this.tileSize.width * this.scaleFactor + 'px',
            height: this.tileSize.height * this.scaleFactor + 'px',
            order: i
          },
          position: i,
          isEmpty: i === 0
        });
      }
    },
    shuffleTiles: function shuffleTiles() {
      var _this2 = this;

      var _loop = function _loop(i, j) {
        var emptyTile = _this2.tiles.find(function (t) {
          return t.isEmpty;
        });
        var movableTiles = _this2.tiles.filter(function (t) {
          return _this2.getAdjacentOrders(emptyTile).indexOf(t.styles.order) > -1;
        });
        _this2.switchTiles(emptyTile, __WEBPACK_IMPORTED_MODULE_1_lodash_sample___default()(movableTiles));
      };

      for (var i = 0, j = this.totalTiles * 5; i < j; ++i) {
        _loop(i, j);
      }

      backupTiles = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.tiles);
    },
    moveTile: function moveTile(tile) {
      var _this3 = this;

      if (tile.isEmpty) {
        return;
      }

      var target = this.tiles.find(function (t) {
        return t.isEmpty && _this3.getAdjacentOrders(tile).indexOf(t.styles.order) > -1;
      });

      target && this.switchTiles(target, tile);
    },
    switchTiles: function switchTiles(a, b) {
      var _ref2 = [b.styles.order, a.styles.order];
      a.styles.order = _ref2[0];
      b.styles.order = _ref2[1];
    },
    getAdjacentOrders: function getAdjacentOrders(tile) {
      var pos = tile.styles.order;
      return [pos % this.size.horizontal ? pos - 1 : null, (pos + 1) % this.size.horizontal ? pos + 1 : null, pos - this.size.horizontal, pos + this.size.horizontal];
    },
    reset: function reset() {
      this.tiles = JSON.parse(backupTiles);
    },
    restart: function restart() {
      this.$emit('restart');
    }
  }
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_blueimp_load_image__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_blueimp_load_image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_blueimp_load_image__);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      image: null,
      size: {
        horizontal: 3,
        vertical: 3
      }
    };
  },


  methods: {
    fileChanged: function fileChanged(e) {
      var _this = this;

      if (!e.target.files.length) {
        this.image = null;
        return;
      }

      __WEBPACK_IMPORTED_MODULE_0_blueimp_load_image___default()(e.target.files[0], function (canvas) {
        _this.image = canvas.toDataURL();
      }, {
        maxWidth: 600,
        maxHeight: 600,
        minWidth: 200,
        minHeight: 200,
        canvas: true
      });
    },
    start: function start() {
      this.$emit('gameStart', {
        image: this.image,
        size: this.size
      });
    },
    reset: function reset() {
      this.image = null;
      document.querySelector('#optionsForm').reset();
    }
  }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['tile'],

  methods: {
    move: function move() {
      this.$emit('moving', this.tile);
    }
  }
});

/***/ }),
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 24 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 25 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(22)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(12),
  /* template */
  __webpack_require__(33),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(25)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(13),
  /* template */
  __webpack_require__(36),
  /* scopeId */
  "data-v-f505e0aa",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(23)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(14),
  /* template */
  __webpack_require__(34),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 33 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "board"
  }, [_c('div', {
    staticClass: "frame-wrapper",
    style: (_vm.frameSize)
  }, [_c('transition', {
    attrs: {
      "duration": 2000,
      "name": "bounce"
    }
  }, [(_vm.valid) ? _c('div', {
    staticClass: "win"
  }, [_vm._v("Hai vinto un viaggio a..."), _c('br'), _c('br'), _vm._v("  DisneyLand Paris!")]) : _vm._e()]), _vm._v(" "), (_vm.showingOriginal && _vm.image) ? _c('div', {
    staticClass: "original",
    style: ({
      background: ("url(" + _vm.image + ")")
    }),
    on: {
      "click": function($event) {
        _vm.showingOriginal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "frame",
    style: (_vm.frameSize)
  }, _vm._l((_vm.tiles), function(tile) {
    return _c('Tile', {
      key: tile.position,
      ref: "tiles",
      refInFor: true,
      attrs: {
        "tile": tile
      },
      on: {
        "moving": _vm.moveTile
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "controls"
  }, [_c('a', {
    staticClass: "shuffle",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.shuffleTiles($event)
      }
    }
  }, [_vm._v("Reshuffle")]), _vm._v(" "), _c('a', {
    staticClass: "reset",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.reset($event)
      }
    }
  }, [_vm._v("Reset")])])])
},staticRenderFns: []}

/***/ }),
/* 34 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile",
    class: {
      empty: _vm.tile.isEmpty
    },
    style: (_vm.tile.styles),
    on: {
      "click": _vm.move
    }
  })
},staticRenderFns: []}

/***/ }),
/* 35 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_vm._m(0), _vm._v(" "), _c('Board', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.playing),
      expression: "playing"
    }],
    ref: "board",
    on: {
      "restart": _vm.restart
    }
  }), _vm._v(" "), _c('OptionsPane', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.playing),
      expression: "!playing"
    }],
    ref: "optionsPane",
    on: {
      "gameStart": _vm.start
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('h1', [_vm._v("???")])])
}]}

/***/ }),
/* 36 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('button', {
    on: {
      "click": _vm.start
    }
  }, [_vm._v("Inizia")])])
},staticRenderFns: []}

/***/ })
],[10]);


// WEBPACK FOOTER //
// static/js/app.0e24787e98f70eea2d00.js